import { render, staticRenderFns } from "./Industries.vue?vue&type=template&id=b03467d2&scoped=true&"
import script from "./Industries.vue?vue&type=script&lang=js&"
export * from "./Industries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b03467d2",
  null
  
)

export default component.exports